import { DataSeriesEntryForecast } from '@/modules/calendar/model/calendar/data-series-entry-forecast';
import { FormattingUtil } from '@/modules/calendar/util/formatting-util';

export function DataSeriesEntryFactory(entry: DataSeriesEntry): DataSeriesEntry {
  entry.diff = () => {
    const actual = entry.actual;
    const forecast = entry.forecast();

    if (actual === null || actual === undefined) return null;

    if (forecast === null || forecast === undefined) return null;

    if (isNaN(parseFloat(actual)) || isNaN(parseFloat(forecast.value))) return null;

    const parseFormatted = (value: string | number) => {
      const formatted = FormattingUtil.formatNumber(value, entry.precision) as string;

      return parseFloat(formatted.replaceAll(',', ''));
    };

    return parseFormatted(parseFormatted(actual) - parseFormatted(forecast.value));
  };

  entry.forecast = () => {
    return (
      entry.forecasts.find(value => value.source === 'USER') ||
      entry.forecasts.find(value => value.source === 'MNI') ||
      undefined
    );
  };

  entry.addForecast = forecast => {
    const index = entry.forecasts.findIndex(value => value.source === forecast.source);

    if (index < 0) {
      entry.forecasts.push(forecast);

      return forecast;
    } else {
      entry.forecasts[index].value = forecast.value;

      return entry.forecasts[index];
    }
  };

  entry.removeUserForecast = () => {
    const index = entry.forecasts.findIndex(value => value.source === 'USER');

    if (index < 0) {
    } else {
      entry.forecasts.splice(index, 1);
    }
  };

  return entry;
}

export interface DataSeriesEntry {
  display: string;
  actual: string;
  previous: string;

  precision?: Precision;

  forecasts: DataSeriesEntryForecast[];

  scale: string;
  type: string;

  dataSeriesId: number;

  previousRevisionEntry?: DataSeriesEntry;

  isPreviousRevision: boolean;
  hasPreviousRevision: boolean;

  hasProvider: boolean;

  forecast(): DataSeriesEntryForecast | undefined;

  diff(): number | null;

  addForecast(forecast: DataSeriesEntryForecast): DataSeriesEntryForecast;

  removeUserForecast(): void;
}

export interface Precision {
  precisionType: 'SIGNIFICANT_FIGURES' | 'DECIMAL_PLACES';
  precisionValue: number;
}
